import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "components/Home";
import Game from "components/Game";
import Video from "components/Video";
import Login from "components/Auth/Login";
import Signup from "components/Auth/Signup";

const AppRoutes = () => {
  return (
    <React.Fragment>
      <Router basename={"/play"}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/game" element={<Game />} />
          <Route exact path="/video" element={<Video />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Signup />} />
        </Routes>
      </Router>
    </React.Fragment>
  );
};

export default AppRoutes;
